// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ExtEnrollmentMedBenClientIdentifiersModel } from './extEnrollmentMedBenClientIdentifiersModel.js';
import type { ExtEnrollmentPatientUpdateDemographicsModel } from './extEnrollmentPatientUpdateDemographicsModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class ExtEnrollmentPatientUpdateRequestModel {
    'clientIdentifiers'?: ExtEnrollmentMedBenClientIdentifiersModel | null;
    'demographics'?: ExtEnrollmentPatientUpdateDemographicsModel | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ExtEnrollmentPatientUpdateRequestModel>> = [
        {
            "name":     "clientIdentifiers",
            "baseName": "clientIdentifiers",
            "type":     "ExtEnrollmentMedBenClientIdentifiersModel"
        },
        {
            "name":     "demographics",
            "baseName": "demographics",
            "type":     "ExtEnrollmentPatientUpdateDemographicsModel"
        },
    ];

    static getAttributeTypeMap() {
        return ExtEnrollmentPatientUpdateRequestModel.attributeTypeMap;
    }
}
